(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-shop-treehood"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SECTION_SELECTOR = '.th-home-products';

    function updateHomeProductsSection(section) {
      var grid = section.querySelector('.th-home-products__grid');
      if (!grid) return;

      var overflows = grid.scrollWidth > grid.clientWidth + 1;
      var link = section.querySelector('.th-home-products__head-link');

      if (link) {
        link.classList.toggle('th-home-products__head-link--hidden', !overflows);
      }

      section.classList.toggle('th-home-products--all-visible', !overflows);
    }

    function updateAllHomeProductsSections() {
      document.querySelectorAll(SECTION_SELECTOR).forEach(updateHomeProductsSection);
    }

    function initHomeProductsOverflowLinks() {
      updateAllHomeProductsSections();

      if (typeof ResizeObserver === 'undefined') return;

      var observer = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var section = entry.target.closest(SECTION_SELECTOR);
          if (section) updateHomeProductsSection(section);
        });
      });

      document.querySelectorAll(SECTION_SELECTOR + ' .th-home-products__grid').forEach(function (grid) {
        observer.observe(grid);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHomeProductsOverflowLinks);
    } else {
      initHomeProductsOverflowLinks();
    }

    window.addEventListener('resize', updateAllHomeProductsSections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var pageContent = document.querySelector('.th-page__content.rte');
    if (!pageContent) return;

    var extraHeadings = pageContent.querySelectorAll('h1');
    extraHeadings.forEach(function(heading, index) {
      if (index === 0) return;
      var replacement = document.createElement('h2');
      replacement.innerHTML = heading.innerHTML;
      replacement.className = heading.className;
      heading.replaceWith(replacement);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
